import React from 'react'
import { Card } from '../../../Components/Common/Card'
import { Flex } from '../../../Components/Common/Flex'
import { Text } from '../../../Components/Common/Text'
import { Button } from '../../../Components/Common/Button'
import { useLocation } from 'react-router-dom'

const DownloadCard = ({ downloadLinks, title }) => {
  const currentURL = useLocation()
  const specificLocation = currentURL.pathname

  const handleDownload = (link, filename) => {
    const a = document.createElement('a')
    a.href = link
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  return (
    <Card style={{ width: specificLocation === '/zucchetti' ? '100%' : '45%', minHeight: '130px' }}>
      <Flex as>
        <Text style={{ marginBottom: '1em' }} value={title} size={18} bold />
        <Flex as row>
          {Array.isArray(downloadLinks) && downloadLinks.length > 0
            ? (
                downloadLinks.map((link, index) => (
                  <Button
                    key={index}
                    icon='sheet-new'
                    label={`Download File ${index === 0 ? 'Viva' : 'Zuccheti'}`}
                    primary
                    onClick={() => handleDownload(link, `output_${index + 1}.xlsx`)}
                    style={{ marginRight: '1em' }}
                  />
                ))
              )
            : (
              <Button
                icon='sheet-new'
                label='Download Excel'
                primary
                onClick={() => handleDownload(downloadLinks, 'output.xlsx')}
              />
              )}
        </Flex>
      </Flex>
    </Card>
  )
}

export default DownloadCard
